import Vue from 'vue'
import update from './update'

Vue.mixin({
  mounted () {
    update.init()
    update.register(this.onUpdate, this._uid)
    this.$hub.on('resize', this.onResize)
    this.$hub.on('scroll', this.onScroll)
  },
  beforeDestroy () {
    if (this._update.unRegister !== void 0) {
      update.unRegister(this._uid)
    }
    this.$hub.off('resize', this.onResize)
    this.$hub.off('scroll', this.onScroll)
  },
  methods: {
    onUpdate () {},
    onResize () {},
    onScroll () {}
  }
})
